const saleBannerSectionId = window.__saleBannerSectionId;

function initSaleTimer(section) {
  if (!section) return;

  if (section.timerInterval) {
    clearInterval(section.timerInterval);
  }

  const selectedDate = section.dataset.time;
  if (!selectedDate) return;

  const dayEl = section.querySelector('.sale-day');
  const hrEl = section.querySelector('.sale-hr');
  const minEl = section.querySelector('.sale-min');
  const secEl = section.querySelector('.sale-sec');

  function updateTimer() {
    const now = new Date().getTime();
    const targetDate = new Date(selectedDate).getTime();
    const distance = targetDate - now;

    if (distance <= 0) {
      clearInterval(section.timerInterval);
      dayEl.textContent = '00';
      hrEl.textContent = '00';
      minEl.textContent = '00';
      if (secEl) secEl.textContent = '00';
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    dayEl.textContent = String(days).padStart(2, '0');
    hrEl.textContent = String(hours).padStart(2, '0');
    minEl.textContent = String(minutes).padStart(2, '0');
    if (secEl) secEl.textContent = String(seconds).padStart(2, '0');
  }

  updateTimer();
  section.timerInterval = setInterval(updateTimer, 1000);
}

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector(`.lp-sale-banner__main--${saleBannerSectionId}`);
  initSaleTimer(section);
});

document.addEventListener('shopify:section:load', function (event) {
  if (event.detail.sectionId !== saleBannerSectionId) return;
  const section = document.querySelector(`.lp-sale-banner__main--${saleBannerSectionId}`);
  initSaleTimer(section);
});

document.addEventListener('shopify:section:unload', function (event) {
  if (event.detail.sectionId !== saleBannerSectionId) return;
  const section = document.querySelector(`.lp-sale-banner__main--${saleBannerSectionId}`);
  if (section?.timerInterval) clearInterval(section.timerInterval);
});